import { render } from "./ManageLogin.vue?vue&type=template&id=9e800588&scoped=true"
import script from "./ManageLogin.vue?vue&type=script&lang=js"
export * from "./ManageLogin.vue?vue&type=script&lang=js"

import "./ManageLogin.vue?vue&type=style&index=0&id=9e800588&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e800588"]])

export default __exports__